export const DEFAULT_LANG = 'en-us';

export const ALL_LANGS = ['en-us', 'en-ca', 'en-gb'];



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/language.js